<template>
    <modal
        name="share-watchlist-type-menu"
        width="697"
        height="auto"
        :adaptive="true"
        :scrollable="true"
        @closed="resetErrorMessage"
    >
        <div class="share-watchlist-type-modal">
            <div class="share-watchlist-type-modal__header">
                <h1 class="share-watchlist-type-modal__title" v-html="$t('WatchListModal.share_watchlist_type_title')"></h1>
                <span class="share-watchlist-type-modal__title-info" v-html="$t('WatchListModal.share_watchlist_type_title_info')"></span>
            </div>
            <div class="share-watchlist-type-modal__select-type">
                <ShareWatchListTypeOptionAll
                    v-on:shareWithAllSubordinates="shareWithAllSubordinates"
                    v-on:removeSharingWithAllSubordinates="removeSharingWithAllSubordinates"
                />
                <ShareWatchListTypeOptionSelect />
            </div>
            <span v-if="shareWatchlistErrorMessage" class="share-watchlist-type-modal__error">
                <span class="icon-notification"></span>
                <span>{{ shareWatchlistErrorMessage }}</span>
            </span>
            <div class="share-watchlist-type-modal__bottom-functions">
                <TotemButton  @click="closeMenu" :label="$t('General.close')" />
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapGetters } from 'vuex'
    import ShareWatchListTypeOptionAll from 'components/user/watchlist/sharewatchlist/selectsharetype/ShareWatchListTypeOptionAll'
    import ShareWatchListTypeOptionSelect from 'components/user/watchlist/sharewatchlist/selectsharetype/ShareWatchListTypeOptionSelect'
    import shareWatchListHelper from 'components/shared/mixins/shareWatchListHelper'

    export default {
        name: 'ShareWatchListTypeModal',
        mixins: [ shareWatchListHelper ],
        components: {
            ShareWatchListTypeOptionAll,
            ShareWatchListTypeOptionSelect
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                userId: 'getUserId',
                watchLists: 'Watchlists/getWatchLists',
                selectedWatchList: 'Watchlists/getSelectedWatchList',
                shareWatchlistErrorMessage: 'Watchlists/getShareWatchlistErrorMessage'
            })
        },
        methods: {
            shareWithAllSubordinates () {
                this.resetErrorMessage()
                this.$emit('shareWithAllSubordinates')
            },
            removeSharingWithAllSubordinates () {
                this.resetErrorMessage()
                this.$emit('removeSharingWithAllSubordinates')
            },
            closeMenu () {
                this.$modal.hide('share-watchlist-type-menu')
            },
            resetErrorMessage () {
                this.$store.dispatch('Watchlists/setShareWatchListErrorMessage', null)
            }
        }

    }
</script>

<style lang="scss" scoped>
    .share-watchlist-type-modal {
        padding: 0 20px;
        font-family: PlusJakartaSans-Regular, sans-serif;
        width: 100%;
        display: flex;
        flex-direction: column;

        .icon-notification {
            margin: 0 5px;
            display:flex;
            align-items: center;
        }

        [class*="mobile"] & {
            padding: 20px 20px;
        }

        &__title {
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 2.2rem;
            display: flex;
            margin: 0 0 15px;
       }

        &__title-info {
            display: flex;
            padding: 0 0 10px;
            font-size: 1.4rem;
            line-height: 150%;
            margin: 0 0 15px;
        }

        &__select-type {
            display: flex;
            flex-direction: row;
            gap: 15px;
            margin: 0 0 15px;

            [class*="mobile"] & {
                flex-direction: column;
            }
        }

        &__bottom-functions {
            display: flex;
            justify-content: center;
        }

        &__error {
            display: flex;
            justify-content: flex-end;
            flex-direction: row;
            font-size: 1.6rem;
            margin: 10px 0;
            color: $guardsman_red;
            font-family: 'Quicksand-Bold';
        }
    }
</style>
